import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import _ from 'lodash';
import ValueField from './ValueField';

const Value = ({ field, applications, max, sum, groupByDistricts, districts, disabled }) => (
  <Field
    name={field}
    component={ValueField}
    values={applications}
    max={max}
    sum={sum}
    groupByDistricts={groupByDistricts}
    districts={districts}
    disabled={disabled}
  />
);

Value.propTypes = {
  field: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  sum: PropTypes.number.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

function mapStateToProps(state, props) {
  let sum = 0;
  if (state.form.budgetVoteForm.values && state.form.budgetVoteForm.values.applicationIds) {
    state.form.budgetVoteForm.values.applicationIds
      .forEach(id => {
        const app = props.applications.find(a => a.id === id);
        sum += (parseFloat(app ? app.cost : 0) || 0);
      });
  }
  return {
    sum: _.round(sum, 2),
  };
}

export default connect(mapStateToProps)(Value);



// WEBPACK FOOTER //
// ./src/components/budget/types/Value.js